import CompanyOverviewTab from "pages/project/details/tabs/CompanyOverviewTab";
import NewsUpdatesTab from "pages/project/details/tabs/NewsUpdatesTab";
import OfferingDocumentTab from "pages/project/details/tabs/OfferingDocumentTab";
import ProjectOverviewTab from "pages/project/details/tabs/ProjectOverviewTab";
import TeamInfoTab from "pages/project/details/tabs/TeamInfoTab";

/** Tab ids, labels (aligned with add-project steps), and detail view components. */
export const PROJECT_DETAILS_TAB_ENTRIES = [
  { id: "projectOverview", label: "Project Details", Component: ProjectOverviewTab },
  { id: "companyOverview", label: "Company Details", Component: CompanyOverviewTab },
  { id: "teamInfo", label: "Who's Involved", Component: TeamInfoTab },
  { id: "offeringDocument", label: "Offering Documents", Component: OfferingDocumentTab },
  { id: "newsUpdates", label: "News & Updates", Component: NewsUpdatesTab },
];

export const PROJECT_DETAILS_TABS = PROJECT_DETAILS_TAB_ENTRIES.map(({ id, label }) => ({ id, label }));

const TAB_COMPONENT_BY_ID = Object.fromEntries(
  PROJECT_DETAILS_TAB_ENTRIES.map(({ id, Component }) => [id, Component]),
);

export function getProjectDetailsTabComponent(tabId) {
  return TAB_COMPONENT_BY_ID[tabId] || ProjectOverviewTab;
}
